import { render, staticRenderFns } from "./DetailedPayments.vue?vue&type=template&id=6ca3e118&"
import script from "./DetailedPayments.vue?vue&type=script&lang=js&"
export * from "./DetailedPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports